'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors, Spacing } from '@lichtblick/theme';
import { Tabs, Text, TextIntro } from '@lichtblick/ui-components';
import { useState } from 'react';
import { RichText } from '../../../helpers/RichText';
import { getColor } from '../../../utils';
import { AImage } from '../../AImage';
import { isSvgImage } from '../../AImage/Picture.helpers';
import { AnchorMark } from '../../shared';
import { HalfSizedColumn, Section } from '../shared';
import { FlexContainer, ImageWrapper, StyledHeadline, SvgWrapper } from './TabsWithTextIntros.styles';
export const ANCHOR_TO_COMPARISON = 'Vergleich';
const elementMappers = {
    h1: ({ children })=>/*#__PURE__*/ _jsx(StyledHeadline, {
            renderAs: "h1",
            size: "S",
            children: children
        }),
    h3: ({ children })=>/*#__PURE__*/ _jsx(StyledHeadline, {
            renderAs: "h3",
            size: "S",
            children: children
        }),
    p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
            renderAs: "p",
            size: "M",
            children: children
        })
};
export const TabsWithTextIntros = ({ tabsWithTextIntros, theme })=>{
    const [activeTab, setActiveTab] = useState(0);
    const { chip, headline, richText } = tabsWithTextIntros[activeTab].textIntro[0];
    const chipProps = chip ? {
        label: chip
    } : undefined;
    const tabs = tabsWithTextIntros.map(({ _uid, component: _1, image, label, subline, textIntro: _2 })=>({
            contentSlot: isSvgImage(image[0].imageMobile.filename) ? /*#__PURE__*/ _jsx(SvgWrapper, {
                children: /*#__PURE__*/ _jsx(AImage, {
                    ...image[0]
                })
            }) : /*#__PURE__*/ _jsx(ImageWrapper, {
                children: /*#__PURE__*/ _jsx(AImage, {
                    ...image[0]
                })
            }),
            headline: label,
            subline
        }));
    return /*#__PURE__*/ _jsxs(Section, {
        backgroundColor: theme ? getColor(theme) : undefined,
        children: [
            /*#__PURE__*/ _jsx(AnchorMark, {
                anchorId: 'Vergleich'
            }),
            /*#__PURE__*/ _jsxs(FlexContainer, {
                children: [
                    /*#__PURE__*/ _jsx(HalfSizedColumn, {
                        children: /*#__PURE__*/ _jsx(TextIntro, {
                            chipProps: chipProps,
                            headline: headline,
                            text: richText && /*#__PURE__*/ _jsx(RichText, {
                                elementMappers: elementMappers,
                                richText: richText
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(HalfSizedColumn, {
                        children: /*#__PURE__*/ _jsx(Tabs, {
                            backgroundColor: theme === 'white' ? Colors.BackgroundGray : Colors.White,
                            gap: Spacing.S,
                            onActiveTabChange: setActiveTab,
                            tabs: tabs
                        })
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=TabsWithTextIntros.js.map